import { mediaItems } from '@/mocks/homeData';

const mediaImages = [
  "https://readdy.ai/api/search-image?query=Abstract%20cinematic%20visual%20with%20warm%20coral%20and%20golden%20gradient%20background%2C%20soft%20glowing%20light%20effects%2C%20minimalist%20film%20poster%20style%20with%20elegant%20geometric%20shapes%20and%20subtle%20texture%2C%20modern%20streaming%20platform%20aesthetic%2C%20no%20text%2C%20warm%20atmospheric%20lighting&width=640&height=400&seq=media-1-2026&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Dark%20moody%20cinematic%20abstract%20visual%20with%20deep%20shadows%20and%20warm%20amber%20accents%2C%20mystery%20and%20suspense%20atmosphere%2C%20layered%20geometric%20shapes%20with%20soft%20glow%2C%20film%20noir%20inspired%20minimalist%20design%2C%20no%20text%2C%20dramatic%20lighting&width=640&height=400&seq=media-2-2026&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Dynamic%20martial%20arts%20inspired%20abstract%20visual%20with%20flowing%20warm%20golden%20gradients%2C%20energetic%20sweeping%20shapes%20reminiscent%20of%20movement%2C%20modern%20wuxia%20aesthetic%20with%20elegant%20composition%2C%20no%20text%2C%20dramatic%20warm%20lighting&width=640&height=400&seq=media-3-2026&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Bright%20playful%20abstract%20visual%20with%20vibrant%20coral%20and%20peach%20gradients%2C%20energetic%20bouncing%20circular%20shapes%2C%20variety%20show%20fun%20atmosphere%2C%20modern%20entertainment%20aesthetic%2C%20no%20text%2C%20cheerful%20warm%20lighting&width=640&height=400&seq=media-4-2026&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Epic%20fantasy%20abstract%20visual%20with%20celestial%20and%20cosmic%20elements%2C%20warm%20golden%20and%20rich%20amber%20gradients%2C%20flowing%20energy%20waves%20reminiscent%20of%20cultivation%20anime%2C%20grand%20scale%20composition%2C%20no%20text%2C%20majestic%20warm%20lighting&width=640&height=400&seq=media-5-2026&orientation=landscape",
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-3">
            精彩片段
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            精选视频
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">
            水果视频平台热门内容精选，点击即可在线观看
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-200 overflow-hidden cursor-pointer"
            >
              <div className="relative aspect-[16/10] bg-background-200 overflow-hidden">
                <img
                  src={mediaImages[i]}
                  alt={`${item.title} - 水果视频平台精彩内容`}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <span className="text-[10px] text-background-50/90 bg-foreground-900/50 backdrop-blur-sm px-2 py-0.5 rounded-full whitespace-nowrap">
                    {item.category}
                  </span>
                  <span className="text-[10px] text-background-50/90 flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.duration}
                  </span>
                </div>
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-play-fill text-xl ml-0.5"></i>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-semibold text-sm text-foreground-900 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}